import feedbackStyle from './feedback.module.css';

export function Feedback() {
  return (
    <div className={feedbackStyle.div}>Обратная связь</div>
  );
}
